import { useQuery } from 'react-query';
import { apiServiceRest } from 'services/api';

import { IActivity } from '../types';

export const URI = () => '/activities';
export const GET_QUERY_KEY = () => 'get-activities';

export const useGetActivities = () => {
  const [apiService] = apiServiceRest<IActivity[]>();

  return useQuery(GET_QUERY_KEY(), () => apiService.get(URI()));
};
export default useGetActivities;
